<template>
  <a-drawer
    :visible="visible"
    :title="title"
    :footer="footer"
    :width="'55%'"
    :placement="placement"
    @close="cancel"
    class="modal"
    :maskClosable="true"
    :destroyOnClose="true"
    :bodyStyle="bodyStyle"
  >
    <data-tabs ref="dataTabs" :model="dataTabsModel"></data-tabs>
  </a-drawer>
</template>

<script>
import {
  addOrEditEquipment, editEquipment,
  getDeptTreeList,
  getDictList,
  getfocalDepartmentsList,
  getUserDepartmentList
} from '@/api/equipmentLedger'
import { } from '@/api/assetLedger'
import { getDeviceTypeTree } from '@/api/deviceType'
import moment from 'moment'
import { getUserList } from '@/api/organizationalStructure'
import DataTabs from '@/views/gasEquipmentLedger/modules/dataTabsModel/dataTabs.vue'

export default {
  name: 'DrawerDetail',
  props: ['disabled'],
  components: {
    DataTabs
  },
  data () {
    return {
      // 抽屉是否显示
      visible: false,
      // 抽屉标题
      title: '',
      footer: false,
      placement: 'right',
      bodyStyle: {
        height: 'calc(100% - 55px)'
      },
      btnLoading: false,
      form: this.$form.createForm(this, { name: 'cancelApplication' }),
      labelCol: { style: 'width: 110px' },
      wrapperCol: { style: 'width: calc(100% - 120px)' },
      showPrincipalName: false,
      dataTabsModel: {},
      // 公司名称列表
      companyNameList: [],
      // 设备状态列表
      equipmentStatusList: [],
      // 使用人员/归口部门负责人
      userOfServiceList: [],
      // 归口部门负责人
      centralizedDepartmentCenter: [],
      // 归口部门列表
      relevantDepartmentList: [],
      // 使用部门列表
      userDepartmentList: [],
      // 专项类型列表
      specialClassificationList: [],
      // 设备类别列表
      equipmentClassList: [],
      // SAP设备分类列表
      SAPEquipmentClassifyList: [],
      // 重要分类列表
      importantClassificationList: [
        {
          id: 'A',
          name: 'A'
        },
        {
          id: 'B',
          name: 'B'
        },
        {
          id: 'C',
          name: 'C'
        },
        {
          id: 'D',
          name: 'D'
        }
      ],
      // 是否列表
      yesOrNoList: [
        {
          id: '是',
          name: '是'
        },
        {
          id: '否',
          name: '否'
        }
      ],
      selectList: [],
      model: {},
      type: '',
      // 公司名称code
      subcompanycode: '',
      subcompanyname: '',
      // 使用部门code
      usedeptcode: '',
      // 使用部门name
      usedeptname: '',
      // 归口部门code
      relevantdeptcode: '',
      // 归口部门name
      relevantdeptname: '',
      // 使用人员code
      principalName: '',
      // 归口部门负责人code
      relevantdeptUserName: '',
      // 专项类型名称
      specialTypeName: '',
      // 设备状态名称
      equipmentStatusName: '',
      // SAP设备分类名称
      sapTypeName: '',
      // 设备类别名称
      equipmentTypeName: ''
    }
  },
  created () {
    // 获取公司名称列表
    this.getCompanyNameList()
    // 获取设备状态列表
    this.getEquipmentStatusList()
    // 获取归口部门列表
    this.getRelevantDepartmentList()
    // 获取专项分类
    this.getSpecialClassificationList()
    // 获取设备类别
    this.getEquipmentClassList()
    // 获取SAP设备分类列表
    this.getSAPEquipmentClassifyList()
  },
  methods: {
    // 设置类型
    setType (type) {
      this.type = type
    },
    // 设置标题
    setTitle (title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel (model, type = 'edit') {
      this.dataTabsModel = model
      // this.subcompanycode = model.subcompanycode
      // this.subcompanyname = model.subcompanyname
      // this.usedeptcode = model.usedeptcode
      // this.usedeptname = model.usedeptname
      // this.relevantdeptcode = model.relevantdeptcode
      // this.relevantdeptname = model.relevantdeptname
      // this.specialTypeName = model.specialTypeName
      // this.equipmentTypeName = model.equipmentTypeName
      // this.equipmentStatusName = model.equipmentStatusName
      // this.sapTypeName = model.sapTypeName
      // this.principalName = model.principalName
      // this.relevantdeptUserName = model.relevantdeptUserName
      // this.getUserDepartmentList(model.subcompanyid, model.subcompanyname)
      // this.getUserOfServiceAndCentralizedList(model.depid)
      // this.getCentralizedDepartmentCenterList(model.relevantdeptid)
      // if (model.principalId) {
      //   this.showPrincipalName = false
      // } else {
      //   this.showPrincipalName = true
      // }
      // this.$nextTick(() => {
      //   this.model = Object.assign({}, model)
      //   const obj = {
      //     'name': model.name,
      //     'specification': model.specification,
      //     'subcompanyid': model.subcompanyid,
      //     'principalId': model.principalId ? model.principalId : 'null',
      //     'principalName': model.principalName,
      //     'equipmentNumber': model.equipmentNumber,
      //     'interiorCode': model.interiorCode,
      //     'manufacturer': model.manufacturer,
      //     'supplier': model.supplier,
      //     'kansw': model.kansw,
      //     'taxRate': model.taxRate,
      //     'qmzj': model.qmzj,
      //     'purchaseOrder': model.purchaseOrder,
      //     'contractNumber': model.contractNumber,
      //     'accepterName': model.accepterName,
      //     'warehouseNumber': model.warehouseNumber,
      //     'wbsNumber': model.wbsNumber,
      //     'projectNumber': model.projectNumber,
      //     'figureNumber': model.figureNumber,
      //     'sapNumber': model.sapNumber,
      //     'sapType': model.sapType,
      //     'importanceType': model.importanceType,
      //     'ifkernel': model.ifkernel,
      //     'specialType': model.specialType,
      //     'ifenvionmental': model.ifenvionmental,
      //     'manufactureFactory': model.manufactureFactory,
      //     'dateInProduced': model.dateInProduced ? moment(model.dateInProduced, 'YYYY-MM-DD HH:ss:dd') : '',
      //     'factoryNumber': model.factoryNumber,
      //     'instructionBook': model.instructionBook,
      //     'entryDate': model.entryDate ? moment(model.entryDate, 'YYYY-MM-DD HH:ss:dd') : '',
      //     'maintenanceDate': model.maintenanceDate ? moment(model.maintenanceDate, 'YYYY-MM-DD HH:ss:dd') : '',
      //     'purchaseDate': model.purchaseDate ? moment(model.purchaseDate, 'YYYY-MM-DD HH:ss:dd') : '',
      //     'deloveryDate': model.deloveryDate ? moment(model.deloveryDate, 'YYYY-MM-DD HH:ss:dd') : '',
      //     'producedDate': model.producedDate ? moment(model.producedDate, 'YYYY-MM-DD HH:ss:dd') : '',
      //     'dateOfDelivery': model.dateOfDelivery ? moment(model.dateOfDelivery, 'YYYY-MM-DD HH:ss:dd') : '',
      //     'outboundDeliveryDate': model.outboundDeliveryDate ? moment(model.outboundDeliveryDate, 'YYYY-MM-DD HH:ss:dd') : '',
      //     'retirementDate': model.retirementDate ? moment(model.retirementDate, 'YYYY-MM-DD HH:ss:dd') : '',
      //     'capitalizationDate': model.capitalizationDate ? moment(model.capitalizationDate, 'YYYY-MM-DD HH:ss:dd') : '',
      //     'arrivalDate': model.arrivalDate ? moment(model.arrivalDate, 'YYYY-MM-DD HH:ss:dd') : '',
      //     'registerCode': model.registerCode,
      //     'certificateNumber': model.certificateNumber,
      //     'inspectionReportNumber': model.inspectionReportNumber,
      //     'quality': model.quality,
      //     'ifverify': model.ifverify,
      //     'equipmentType': model.equipmentType,
      //     'assetNumber': model.assetNumber,
      //     'usedeptid': model.usedeptid,
      //     'relevantdeptid': model.relevantdeptid,
      //     'equipmentStatus': model.equipmentStatus,
      //     'relevantdeptUserId': model.relevantdeptUserId,
      //     'buyer': model.buyer,
      //     'purchaseRequestUser': model.purchaseRequestUser,
      //     'remark': model.remark,
      //     'ifsecurity': model.ifsecurity
      //   }
      //   if (type === 'copy') {
      //     delete obj.equipmentNumber
      //     delete obj.interiorCode
      //   }
      //   this.form.setFieldsValue(obj)
      // })
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      if (flag) {
        if (this.type === 'add') {
          this.$nextTick(() => {
            this.form.setFieldsValue({
              'subcompanyid': this.companyNameList[0].id,
              'relevantdeptid': this.relevantDepartmentList[0].deptId
            })
            this.subcompanycode = this.companyNameList[0].subcompanycode
            this.subcompanyname = this.companyNameList[0].subcompanyname
            this.relevantdeptcode = this.relevantDepartmentList[0].departmentcode
            this.relevantdeptname = this.relevantDepartmentList[0].departmentname
            this.getUserDepartmentList(this.companyNameList[0].id)
            this.getCentralizedDepartmentCenterList(this.relevantDepartmentList[0].deptId)
          })
        } else {
        }
      }
      this.visible = flag
    },
    // 重置children数组
    resetTheChildrenArray (children) {
      const arr = []
      const self = this
      if (children && children.length > 0) {
        for (let i = 0; i < children.length; i++) {
          const item = JSON.parse(JSON.stringify(children[i]))
          if (item.children && item.children.length) {
            item.disabled = true
            item.children = self.resetTheChildrenArray(item.children)
          }
          arr.push(item)
        }
      }
      return arr
    },
    // 获取公司名称列表
    getCompanyNameList () {
      const data = {
        paging: false
      }
      getDeptTreeList(data).then(res => {
        if (res.status === 0) {
          res.data.map(item => {
            if (item.children.length > 0) {
              item.disabled = true
            }
            item.children = this.resetTheChildrenArray(item.children)
          })
          this.companyNameList = res.data
        } else {
          this.$message.error(res.info.message)
        }
      })
    },
    // 获取设备状态列表
    getEquipmentStatusList () {
      const data = {
        pCode: 'sb_sbzt'
      }
      getDictList(data).then(res => {
        if (res.status === 0) {
          this.equipmentStatusList = res.data
        }
      })
    },
    // 获取归口部门列表
    getRelevantDepartmentList () {
      getfocalDepartmentsList().then(res => {
        if (res.status === 0) {
          this.relevantDepartmentList = res.data
        }
      })
    },
    // 获取使用部门列表
    getUserDepartmentList (comid) {
      const data = {
        paging: false,
        comid: comid
      }
      getUserDepartmentList(data).then(res => {
        if (res.status === 0) {
          this.userDepartmentList = res.data
        }
      })
    },
    // 获取使用人员
    getUserOfServiceAndCentralizedList (depid) {
      const data = {
        depid: depid,
        paging: false
      }
      getUserList(data).then(res => {
        if (res.status === 0) {
          this.userOfServiceList = res.data
        }
      })
    },
    // 获取归口部门负责人
    getCentralizedDepartmentCenterList (depid) {
      const data = {
        depid: depid,
        paging: false
      }
      getUserList(data).then(res => {
        if (res.status === 0) {
          this.centralizedDepartmentCenter = res.data
        }
      })
    },
    // 获取专项类型
    getSpecialClassificationList () {
      const data = {
        pCode: 'sb_zxlx'
      }
      getDictList(data).then(res => {
        if (res.status === 0) {
          this.specialClassificationList = res.data
        }
      })
    },
    // 获取设备类别
    getEquipmentClassList () {
      getDeviceTypeTree().then(res => {
        if (res.status === 0) {
          this.equipmentClassList = res.data
        }
      })
    },
    // 获取SAP设备分类
    getSAPEquipmentClassifyList () {
      const data = {
        pCode: 'zcfl'
      }
      getDictList(data).then(res => {
        if (res.status === 0) {
          this.SAPEquipmentClassifyList = res.data
        }
      })
    },
    // 改变公司选择
    changeCompany (value, label, extra) {
      if (extra.triggerNode) {
        this.subcompanycode = extra.triggerNode.$vnode.data.props.dataRef.subcompanycode
        this.subcompanyname = extra.triggerNode.$vnode.data.props.dataRef.subcompanyname
      } else {
        this.subcompanycode = ''
        this.subcompanyname = ''
      }
      this.form.setFieldsValue(
        {
          usedeptid: undefined,
          principalId: undefined,
          principalName: undefined,
          relevantdeptUserId: undefined,
          relevantdeptid: undefined
        }
      )
      // 重置使用部门下拉列表
      this.userDepartmentList = []
      // 重置使用部门
      this.usedeptcode = ''
      this.usedeptname = ''
      // 重置使用人员/归口部门负责人下拉列表
      this.userOfServiceList = []
      this.centralizedDepartmentCenter = []
      // 重置使用人员
      this.principalName = ''
      // 重置归口部门负责人
      this.relevantdeptcode = ''
      this.relevantdeptname = ''
      this.relevantdeptUserName = ''
      // 获取使用部门
      this.getUserDepartmentList(value)
    },
    // 改变设备类别
    changeEquipmentType (value, label, extra) {
      if (extra.triggerNode) {
        this.equipmentTypeName = extra.triggerNode.$vnode.data.props.dataRef.name
      } else {
        this.equipmentTypeName = ''
      }
    },
    // 改变专项类型
    changeSpecialType (value) {
      if (value) {
        const index = this.specialClassificationList.findIndex(item => item.code === value)
        this.specialTypeName = this.specialClassificationList[index].name
      } else {
        this.specialTypeName = ''
      }
    },
    // 改变设备状态
    changeEquipmentStatus (value) {
      if (value) {
        const index = this.equipmentStatusList.findIndex(item => item.code === value)
        this.equipmentStatusName = this.equipmentStatusList[index].name
      } else {
        this.equipmentStatusName = ''
      }
    },
    // 改变SAP设备分类
    changeSapType (value) {
      if (value) {
        const index = this.SAPEquipmentClassifyList.findIndex(item => item.code === value)
        this.sapTypeName = this.SAPEquipmentClassifyList[index].name
      } else {
        this.sapTypeName = ''
      }
    },
    // 改变归口部门
    changeRelevantDept (value) {
      if (value) {
        const index = this.relevantDepartmentList.findIndex(item => item.deptId === value)
        this.relevantdeptcode = this.relevantDepartmentList[index].departmentcode
        this.relevantdeptname = this.relevantDepartmentList[index].departmentname
        this.getCentralizedDepartmentCenterList(value)
      } else {
        this.relevantdeptcode = ''
        this.relevantdeptname = ''
      }
      //  重置归口部门负责人
      this.$nextTick(() => {
        this.form.setFieldsValue({
          relevantdeptUserId: undefined
        })
      })
      this.relevantdeptUserName = ''
    },
    // 改变使用部门选择
    changeUseDept (value, label, extra) {
      if (extra.triggerNode) {
        this.usedeptcode = extra.triggerNode.$vnode.data.props.dataRef.departmentcode
        this.usedeptname = extra.triggerNode.$vnode.data.props.dataRef.departmentname
        this.getUserOfServiceAndCentralizedList(extra.triggerNode.$vnode.data.props.dataRef.depid)
      } else {
        this.usedeptcode = ''
        this.usedeptname = ''
      }
      //  重置使用人员
      this.$nextTick(() => {
        this.form.setFieldsValue({
          principalId: undefined,
          principalName: undefined
        })
      })
      this.userOfServiceList = []
      this.principalName = ''
    },
    // 改变使用人员
    changeUseDeptPersonnel (value) {
      this.form.setFieldsValue({
        principalName: undefined
      })
      if (value) {
        if (value === 'null') {
          this.showPrincipalName = true
        } else {
          this.showPrincipalName = false
          const index = this.userOfServiceList.findIndex(item => item.id === value)
          this.principalName = this.userOfServiceList[index].lastname
        }
      } else {
        this.principalName = ''
        this.showPrincipalName = false
      }
    },
    // 改变归口部门负责人
    changeCentralizeDeptPersonnel (value) {
      if (value) {
        const index = this.centralizedDepartmentCenter.findIndex(item => item.id === value)
        this.relevantdeptUserName = this.centralizedDepartmentCenter[index].lastname
      } else {
        this.relevantdeptUserName = ''
      }
    },
    // 搜索使用部门
    filterTreeNode (inputValue, treeNode) {
      return treeNode.data.props.title.includes(inputValue)
    },
    // 提交
    handleSubmit (e) {
      e.preventDefault()
      this.btnLoading = true
      this.form.validateFieldsAndScroll(async (err, value) => {
        if (!err) {
          const params = { ...value }
          params.subcompanycode = this.subcompanycode
          params.subcompanyname = this.subcompanyname
          params.usedeptcode = this.usedeptcode
          params.usedeptname = this.usedeptname
          params.relevantdeptcode = this.relevantdeptcode
          params.relevantdeptname = this.relevantdeptname
          params.specialTypeName = this.specialTypeName
          params.equipmentTypeName = this.equipmentTypeName
          params.equipmentStatusName = this.equipmentStatusName
          params.sapTypeName = this.sapTypeName ? this.sapTypeName : null
          params.principalName = params.principalId === 'null' ? params.principalName : this.principalName
          params.relevantdeptUserName = this.relevantdeptUserName
          params.dateInProduced = params.dateInProduced ? params.dateInProduced.format('YYYY-MM-DD 00:00:00') : ''
          params.entryDate = params.entryDate ? params.entryDate.format('YYYY-MM-DD 00:00:00') : ''
          params.maintenanceDate = params.maintenanceDate ? params.maintenanceDate.format('YYYY-MM-DD 00:00:00') : ''
          params.purchaseDate = params.purchaseDate ? params.purchaseDate.format('YYYY-MM-DD 00:00:00') : ''
          params.deloveryDate = params.deloveryDate ? params.deloveryDate.format('YYYY-MM-DD 00:00:00') : ''
          params.producedDate = params.producedDate ? params.producedDate.format('YYYY-MM-DD 00:00:00') : ''
          params.dateOfDelivery = params.dateOfDelivery ? params.dateOfDelivery.format('YYYY-MM-DD 00:00:00') : ''
          params.outboundDeliveryDate = params.outboundDeliveryDate ? params.outboundDeliveryDate.format('YYYY-MM-DD 00:00:00') : ''
          params.retirementDate = params.retirementDate ? params.retirementDate.format('YYYY-MM-DD 00:00:00') : ''
          params.capitalizationDate = params.capitalizationDate ? params.capitalizationDate.format('YYYY-MM-DD 00:00:00') : ''
          params.arrivalDate = params.arrivalDate ? params.arrivalDate.format('YYYY-MM-DD 00:00:00') : ''
          if (params.principalId === 'null') {
            params.principalId = null
          }
          if (this.type === 'edit') {
            params.id = this.model.id
          }
          addOrEditEquipment(params).then(res => {
            if (res.status === 0) {
              this.$message.success('保存成功')
              this.$emit('getTableData', false)
              this.$emit('getDataTabs', params.id)
              this.btnLoading = false
              this.cancel()
            } else {
              this.$message.error(res.info.message)
              this.btnLoading = false
            }
          })
        } else {
          this.btnLoading = false
        }
      })
    },
    // 关闭抽屉
    cancel () {
      this.formClear()
      this.open(false)
    },
    // 重置
    formClear () {
      this.$nextTick(() => {
        this.form.resetFields()
        this.userDepartmentList = []
        this.userOfServiceList = []
        // 重置使用人员
        this.principalName = ''
        this.showPrincipalName = false
        // 重置归口部门负责人
        this.relevantdeptUserName = ''
        this.subcompanycode = ''
        this.subcompanyname = ''
        this.usedeptcode = ''
        this.usedeptname = ''
        this.relevantdeptcode = ''
        this.relevantdeptname = ''
        this.specialTypeName = ''
        this.equipmentTypeName = ''
        this.equipmentStatusName = ''
        this.sapTypeName = ''
      })
    }
  }
}
</script>

<style scoped lang="less">
.rightTableDiv {
  height: 100%;
  overflow: hidden;
}
.titleDiv {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  .title{
    color: #08409F;
    padding-left: 8px;
    font-weight: bold;
  }
}
.inputDiv {
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 1;
}
.btn {
   display: flex;
   flex-direction: row;
   justify-content: flex-end;
  .cancel {
    margin-left: 20px;
  }
 }
/deep/.ant-form-item {
  display: flex;
  margin-bottom: 12px;
}
/deep/.ant-col-md-5 {
  width: 20% !important;
  margin-bottom: 12px;
}
/deep/.ant-col-md-9 {
  width: 40% !important;
  margin-bottom: 12px;
}
/deep/.ant-form-explain {
  position: absolute;
}
// 线颜色修改
/deep/.ant-table-bordered .ant-table-header > table{
  //border-color: rgba(185, 222, 255, 1) !im;
}
/deep/.ant-table-bordered .ant-table-thead > tr > th{
  border-right: 0.8px solid rgba(185, 222, 255, 1);
  border-bottom: 0.8px solid rgba(185, 222, 255, 1);
  background-color: #fff !important;
}
/deep/.ant-table-bordered .ant-table-body{
  border-left: 0.8px solid rgba(185, 222, 255, 1);
}
/deep/.ant-table-bordered .ant-table-body > table{
  border-top: 0.8px solid rgba(185, 222, 255, 1);
  border-left: 0.8px solid rgba(185, 222, 255, 1);
  border-right: 0.8px solid rgba(185, 222, 255, 1);
}
/deep/.ant-table-bordered .ant-table-tbody > tr > td{
  border-right: 0.8px solid rgba(185, 222, 255, 1);
  border-bottom: 0.8px solid rgba(185, 222, 255, 1);
}
/deep/.ant-table-tbody > tr > td{
  //border-bottom: 0.8px solid rgba(185, 222, 255, 1);
}
/deep/.ant-table-tbody > tr.ant-table-row-selected td{
  background-color: rgba(225, 225, 225, 0);
}
/deep/.ant-table-bordered.ant-table-fixed-header .ant-table-header > table{
  border-top: 0.8px solid rgba(185, 222, 255, 1);
  border-bottom: 1.6px solid rgba(185, 222, 255, 1);
}
/deep/.ant-table.ant-table-bordered .ant-table-footer{
  border: none !important;
}
/*有固定行的ant-design-vue 表格滑动样式*/
/deep/.ant-table-fixed .ant-table-row-hover {
  background: rgb(245, 247, 250) !important;
}
/deep/.ant-table-fixed .ant-table-row-hover > td {
  background: rgb(245, 247, 250) !important;
}
/*没有固定行的表格个样式*/
/deep/.ant-table-tbody > tr:hover:not(.ant-table-expanded-row) > td {
  background-color: rgb(245, 247, 250) !important;
}
/deep/.ant-table-body .ant-table-row-hover {
  background: rgb(245, 247, 250) !important;
}
/deep/.ant-table-body .ant-table-row-hover > td {
  background: rgb(245, 247, 250) !important;
}
</style>
